<template>
    <div class="list-add-to-cart-mobile">
        <div class="d-flex flex-justify-between flex-align-center">
            <h3 class="mr-1">{{ product.name }}</h3>
            <i class="icon-cr icon-close" @click.prevent="$emit('close')"></i>
        </div>
        <div class="d-flex prices mt-2">
            <div v-show="product.price_old" class="mr-3">
                <span>de:</span> {{ $f.formatMoney(product.price_old) }}
            </div>
            <div>
                <span v-show="product.price_old">por:</span> {{ $f.formatMoney(product.price) }}
                <span>até 4x</span>
            </div>
        </div>
        <div class="mt-3 mb-3 text-bold" style="float: right">
            <a class="text-no-decoration" :href="product.link"><u>Ver página do produto</u></a>
        </div>
        <ProductVariations :product="product" @input="showEquivalentSize" :shop-mode="true">
            <template v-slot:list-add-to-cart-mobile>
                <slot name="list-add-to-cart-mobile">
                    <button class="btn btn-lg text-uppercase mt-2" @click="handleAddToCart">
                        Adicionar à sacola
                    </button>
                </slot>
            </template>
            <template v-slot:select-size-error>
                <slot name="select-size-error">
                    <p class="select-size-error" v-if="sizeError">{{ sizeError }}</p>
                </slot>
            </template>
        </ProductVariations>
    </div>
</template>

<script>
    import BaseVariations from './BaseVariations.vue';
    import ProductVariations from './ProductVariations.vue';

    export default {
        name: 'ProductListAddToCartMobile',
        components: { ProductVariations },

        extends: BaseVariations,

        watch: {
            selectedVariation: {
                immediate: true,
                handler(to) {
                    this.sizeError = null;
                },
            },
        },
        
        methods: {
            handleAddToCart(){
                this.reportToTagManager();
                this.addToCart(false, true);
            }
        },
    };
</script>
